import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFacturationMode } from '../../api/TICKET/ticketMeta';
import { toast } from 'react-toastify';

export const useCreateFacturationMode = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createFacturationMode,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['facturationModes'] });
            toast.success('Méthode de facturation créée avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la création de la méthode de facturation');
        },
    });
};
